import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
 
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const errorPage = r => require.ensure([], () => r(require('@/components/errorPage')))
const  loginmyadmin= r => require.ensure([], () => r(require('@/components/loginmyadmin')))
const  home= r => require.ensure([], () => r(require('@/components/home')))
const exp = r => require.ensure([], () => r(require('@/components/exp')))
const  Chatwindow= r => require.ensure([], () => r(require('@/components/Chatwindow')))
const texts = r => require.ensure([], () => r(require('@/components/texts')))
const  ceshi= r => require.ensure([], () => r(require('@/components/ceshi')))
//官网展示
const  index= r => require.ensure([], () => r(require('@/components/index')))
const Method = r => require.ensure([], () => r(require('@/components/Method')))
// const quangu = r => require.ensure([], () => r(require('@/components/quangu')))
const jiqiren = r => require.ensure([], () => r(require('@/components/jiqiren')))
const robotall = r => require.ensure([], () => r(require('@/components/robotall')))
const gongju = r => require.ensure([], () => r(require('@/components/gongju')))

//工具类
const wendang = r => require.ensure([], () => r(require('@/components/gongju/wendang')))
const shiming = r => require.ensure([], () => r(require('@/components/gongju/shiming')))
const chatgpt = r => require.ensure([], () => r(require('@/components/gongju/chatgpt')))
const chatlist = r => require.ensure([], () => r(require('@/components/gongju/chatlist')))
const acupoint = r => require.ensure([], () => r(require('@/components/gongju/acupoint')))
const huibaoAccount = r => require.ensure([], () => r(require('@/components/gongju/huibaoAccount')))


//我的余额
const  balance= r => require.ensure([], () => r(require('@/components/home/balance/balance')))
const  remaining= r => require.ensure([], () => r(require('@/components/home/balance/remaining')))
const  invoice= r => require.ensure([], () => r(require('@/components/home/balance/invoice')))




//我的店铺
const  shop= r => require.ensure([], () => r(require('@/components/home/myshop/shop')))
const  shopCreate= r => require.ensure([], () => r(require('@/components/home/myshop/shopCreate')))

//代金券
const  coupon= r => require.ensure([], () => r(require('@/components/home/coupon/coupon')))
const  couponCreate= r => require.ensure([], () => r(require('@/components/home/coupon/couponCreate')))
const  orderCoupon= r => require.ensure([], () => r(require('@/components/home/coupon/orderCoupon')))
const  userCoupon= r => require.ensure([], () => r(require('@/components/home/coupon/userCoupon')))

//核单
const  hedan= r => require.ensure([], () => r(require('@/components/home/hedan/hedan')))
const  hedanCreate= r => require.ensure([], () => r(require('@/components/home/hedan/hedanCreate')))

//核单
const  robot= r => require.ensure([], () => r(require('@/components/home/robot/robot')))
const  robotAdd= r => require.ensure([], () => r(require('@/components/home/robot/robotAdd')))
const  robotUpdate= r => require.ensure([], () => r(require('@/components/home/robot/robotUpdate')))


//查询商户
const  Merchant= r => require.ensure([], () => r(require('@/components/home/robot/Merchant')))
const  Balance= r => require.ensure([], () => r(require('@/components/home/robot/Balance')))
const  payMode= r => require.ensure([], () => r(require('@/components/home/robot/payMode')))
const  Merchant_jiaoyi= r => require.ensure([], () => r(require('@/components/home/robot/Merchant_jiaoyi')))
const  summon= r => require.ensure([], () => r(require('@/components/home/robot/summon')))
const  summonAdd= r => require.ensure([], () => r(require('@/components/home/robot/summonAdd')))
const summonUpdate = r => require.ensure([], () => r(require('@/components/home/robot/summonUpdate')))

//api

const informationApi = r => require.ensure([], () => r(require('@/components/gongju/informationApi')))
const informationApidetails = r => require.ensure([], () => r(require('@/components/gongju/informationApidetails')))



Vue.use(Router)

 const router = new Router({
  mode: 'history',
  routes: [
  	{
      path: '*',
      component: errorPage
   }, 
   {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/Method',
      name: 'Method',
      component: Method,
	  }, 
	//   {
	// 	path: '/quangu',
	// 	name: 'quangu',
	// 	component: quangu,
	//   }, 
	  {
		path: '/jiqiren',
		name: 'jiqiren',
		component: jiqiren,
	  },
	  {
		path: '/gongju',
		name: 'gongju',
		component: gongju,
	  },
    {
      path: '/robotall',
      name: 'robotall',
      component: robotall,
    },
    {
      path: '/texts',
      name: 'texts',
      component: texts,
	  },
	  {
		path:'/Chatwindow',
		name:'Chatwindow',
		component:Chatwindow,
	  },
	  {
		path:'/ceshi',
		name:'ceshi',
		component:ceshi,
	},
	{
		path:'/wendang',
		name:'wendang',
		component:wendang,
	  },
	  {
		path:'/shiming',
		name:'shiming',
		component:shiming,
	  }, 
	  {
		path:'/chatgpt',
		name:'chatgpt',
		component:chatgpt,
	  },
	  {
		path:'/chatlist',
		name:'chatlist',
		component:chatlist,
	  },
	  {
		path:'/acupoint',
		name:'acupoint',
		component:acupoint,
	  },
	  {
		path:'/huibaoAccount',
		name:'huibaoAccount',
		component:huibaoAccount,
	  },
	  {
		path:'/informationApi',
		name:'informationApi',
		component:informationApi,
	  },
	  {
		path:'/informationApidetails',
		name:'informationApidetails',
		component:informationApidetails,
	  },
	  
	  
    {
      path: '/home',
      component: home,
    	children:[
	  		{
	  			path:'/shop',
		  		name:'shop',
				component: shop,
	  		},
	  		{
	  			path:'/shop/shopCreate',
		  		name:'shopCreate',
		  		component:shopCreate,
	  		},
	  		{
	  			path:'/coupon',
		  		name:'coupon',
		  		component:coupon,
			},
			{
				path:'/balance',
				name:'balance',
			  component: balance,
			},
			{
				path:'/remaining',
				name:'remaining',
			  component: remaining,
			},
			
			{
				path:'/invoice',
				name:'invoice',
			  component: invoice,
			},
	  		{
	  			path:'/coupon/couponCreate',
		  		name:'couponCreate',
		  		component:couponCreate,
	  		},
	  		{
	  			path:'/userCoupon',
		  		name:'userCoupon',
		  		component:userCoupon,
	  		},
	  		{
	  			path:'/orderCoupon',
		  		name:'orderCoupon',
		  		component:orderCoupon,
	  		},
	  		{
	  			path:'/hedan',
		  		name:'hedan',
		  		component:hedan,
	  		},
	  		{
	  			path:'/hedan/hedanCreate',
		  		name:'hedanCreate',
		  		component:hedanCreate,
	  		},
	  		{
	  			path:'/robot',
		  		name:'robot',
		  		component:robot,
	  		},
	  		{
	  			path:'/robot/robotAdd',
		  		name:'robotAdd',
		  		component:robotAdd,
	  		},
	  		{
	  			path:'/robot/robotUpdate',
		  		name:'robotUpdate',
		  		component:robotUpdate,
	  		},
	  		{
	  			path:'/robot/Merchant',
		  		name:'Merchant',
		  		component:Merchant,
	  		},
	  		{
	  			path:'/robot/Balance',
		  		name:'Balance',
		  		component:Balance,
	  		},
	  		{
	  			path:'/robot/payMode',
		  		name:'payMode',
		  		component:payMode,
	  		},
	  		{
	  			path:'/Merchant_jiaoyi',
		  		name:'Merchant_jiaoyi',
		  		component:Merchant_jiaoyi,
	  		},
	  		{
	  			path:'/robot/summon',
		  		name:'summon',
		  		component:summon,
	  		},
	  		{
	  			path:'/robot/summonAdd',
		  		name:'summonAdd',
		  		component:summonAdd,
	  		},
	  		{
	  			path:'/robot/summonUpdate',
		  		name:'summonUpdate',
		  		component:summonUpdate,
	  		},
	  		{
	  			path:'/exp',
		  		name:'exp',
		  		component:exp,
			},
			
    	]
	  },
	  	
    {
      path: '/loginmyadmin',
      name: 'loginmyadmin',
      component: loginmyadmin,
    },    
  ]
})


//路由守卫
router.beforeEach((to, from, next) => {
	
	//设置标题
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
	if(from.name=='loginReg'&&to.name=='setUp'){
		next({path: '/my'})
	}  
  next();
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js